import axios from 'axios';
import { API_CONFIG, DEV_CONFIG } from '../config/env';

const axiosBaseQuery = ({ baseUrl } = { baseUrl: '' }) =>
    async ({ url, method, body, params, headers }) => {
        try {
            // Get token from localStorage
            const token = localStorage.getItem('authToken') || localStorage.getItem('token');

            // Log API calls in debug mode
            if (DEV_CONFIG.IS_DEBUG) {
                console.log(`API Call: ${method?.toUpperCase()} ${baseUrl}${url}`, {
                    params,
                    body,
                    headers: { ...headers, Authorization: token ? 'Bearer ***' : undefined }
                });
            }

            const result = await axios({
                url: baseUrl + url,
                method,
                data: body,
                params,
                timeout: API_CONFIG.TIMEOUT,
                headers: {
                    'Content-Type': 'application/json',
                    ...(token && { Authorization: `Bearer ${token}` }),
                    ...headers,
                },
            });

            return {
                data: result.data,
            };
        } catch (axiosError) {
            const err = axiosError;
            
            // Log errors in debug mode
            if (DEV_CONFIG.IS_DEBUG) {
                console.error(`API Error: ${method?.toUpperCase()} ${baseUrl}${url}`, {
                    status: err.response?.status,
                    data: err.response?.data,
                    message: err.message
                });
            }
            
            return {
                error: {
                    status: err.response?.status,
                    data: err.response?.data || err.message,
                },
            };
        }
    };

export { axiosBaseQuery };